import type { FC } from "react";
import { useState, useEffect } from "react";

import capitalize from "lodash/capitalize";

import { ChipDownContainer } from "@similarweb/ui-components";

import { allTrackers } from "app/services/track/track";
import { translate } from "app/filters/i18nFilter";
import { getWebsiteTypeItems, getWebsiteTypeOptions } from "app/pages/keyword-analysis/Organic";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { IWebsiteFilterProps } from "./Types";

export const WebsiteFilter: FC<IWebsiteFilterProps> = ({ onFilterChange, onDropdownToggle, selectedWebsiteFilter }) => {
    const [websiteType, setWebsiteType] = useState<string>();
    const websiteOptions = getWebsiteTypeOptions();

    useEffect(() => {
        if (selectedWebsiteFilter) {
            const websiteTypeItem = websiteOptions.filter((item) => item.id === selectedWebsiteFilter);
            setWebsiteType(translate(websiteTypeItem[0]?.text));
        }
    }, [selectedWebsiteFilter]);

    const onWebsiteTypeItemClick = (websiteType) => {
        allTrackers.dispatchTrackEvent("Filter Table", "click", `filter/selected/${websiteType.text}`);
        setWebsiteType(websiteType.text);
        onFilterChange({ funcFlag: parseInt(websiteType.id) }, true);
        proNavigator.updateParams({ funcFlag: parseInt(websiteType.id) });
    };
    const onCloseWebsiteTypeItem = () => {
        setWebsiteType(undefined);
        onFilterChange({ funcFlag: null }, true);
        proNavigator.updateParams({ funcFlag: null });
    };
    return (
        <ChipDownContainer
            width={280}
            hasSearch={false}
            selectedIds={websiteType ? ({ [websiteType]: true } as { [key: string]: boolean }) : undefined}
            selectedText={websiteType ? capitalize(websiteType) : ""}
            buttonText={translate("analysis.source.search.keywords.filters.websitetype")}
            onToggle={onDropdownToggle}
            onClick={onWebsiteTypeItemClick}
            onCloseItem={onCloseWebsiteTypeItem}
            noResultsMessage={translate("dropdown.no.results")}
        >
            {getWebsiteTypeItems()}
        </ChipDownContainer>
    );
};
